export const LOAN_TYPES = ["mortgage", "consumerLoan"] as const;

export type LoanType = (typeof LOAN_TYPES)[number];

const LOAN_TYPES_WITH_FIXATION: LoanType[] = ["mortgage"];

export const hasLoanFixation = (loanType: LoanType) =>
	LOAN_TYPES_WITH_FIXATION.includes(loanType);
